import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ResultStatus } from "@app/core/models/result-status";
import { WINDOW } from "@app/core/providers/window.provider";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { CommunityService } from "@app/core/services/community.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { PostReferralComponent } from "../post-referral/post-referral.component";
import { ShareUpdateComponent } from "../share-update/share-update.component";
import * as _ from "lodash";
import { HelperService } from '@app/core/services/helper.service';

@Component({
  selector: "app-post-item-container",
  templateUrl: "./post-item-container.component.html",
  styleUrls: ["./post-item-container.component.scss"]
})
export class PostItemContainerComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild("shareUrlTemplate") shareUrlTemplate: ElementRef;
  @ViewChild("notificationSettingTemplate") notificationSettingTemplate: ElementRef;
  @Input() groupId: number;
  @Input() tagName: string;
  @Input() hasSavedPost: boolean;
  @Input() hasReportedPost: boolean;
  @Input() filterValue = [];
  @Output() openCommunityMenu = new EventEmitter();
  @Output() changeSelectedValue = new EventEmitter();
  @Output() removeAppliedFilter = new EventEmitter();
  isDataLoaded = false;
  postItemList = [];
  throttle = 300;
  scrollDistance = 6;
  scrollUpDistance = 6;
  modalRef: BsModalRef;
  pageNo = 1;
  shareUrl;
  baseShareUrl = "community/post/detail/";
  notificationSettings: NotificationSetting;
  groupName = '';

  constructor(
    @Inject(WINDOW) private window: Window,
    private communityService: CommunityService,
    private modalService: BsModalService,
    private toaterService: ToastrService,
    private authService: AuthenticationService,
    private helperService: HelperService
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.communityService.SharedFeedPostComponent.scrollPosition = window.pageYOffset;
    this.communityService.SharedFeedPostComponent.feedPostList = this.postItemList;
    this.communityService.SharedFeedPostComponent.hasValue = true;
    this.communityService.SharedFeedPostComponent.pageNumber = this.pageNo;
  }

  ngOnChanges() {
    if (this.communityService.SharedFeedPostComponent.hasValue === false) {
      this.isDataLoaded = false;
      this.pageNo = 1;
      this.postItemList = [];
      this.getCommunityPost();
    } else {
      this.postItemList = this.communityService.SharedFeedPostComponent.feedPostList;
      this.isDataLoaded = true;
      this.pageNo = this.communityService.SharedFeedPostComponent.pageNumber;
      setTimeout(() => {
        window.scrollTo(0, this.communityService.SharedFeedPostComponent.scrollPosition);
        this.communityService.SharedFeedPostComponent.hasValue = false;
      }, 500);
    }

    if (this.groupId > 0) {
      this.getNotificationSetting();
    } else {
      this.notificationSettings = null;
    }
  }

  getCommunityPost() {
    if (this.hasReportedPost) {
      this.communityService.getReportedPost().subscribe((result) => {
        this.isDataLoaded = true;
        if (result.Status === ResultStatus.Success) {
          this.addItems(result.Data);
        } else {
          this.toaterService.error("something went wrong");
        }
      });
    } else if (!this.hasSavedPost) {
      this.communityService
        .getCommunityPost(this.groupId, this.tagName, this.pageNo)
        .subscribe(
          (result) => {
            this.isDataLoaded = true;
            if (result.Status === ResultStatus.Success) {
              // this.postItemList = result.Data;
              this.addItems(result.Data);
            } else {
              this.toaterService.error("something went wrong");
            }
          },
          (error) => { }
        );
    } else {
      this.communityService.getAllBookmarkedPost().subscribe(
        (result) => {
          this.isDataLoaded = true;
          if (result.Status === ResultStatus.Success) {
            // this.postItemList = result.Data;
            this.addItems(result.Data);
          } else {
            this.toaterService.error("something went wrong");
          }
        },
        (error) => { }
      );
    }
  }

  addItems(responseData) {
    responseData.forEach((element) => {
      if (this.postItemList.findIndex((item) => item.ID === element.ID) < 0) {
        this.postItemList.push(element);
      } else {
        this.postItemList[
          this.postItemList.findIndex((item) => item.ID === element.ID)
        ] = element;
      }
    });

    const postItemListObject = this.postItemList;
    this.postItemList = _.orderBy(postItemListObject, ["DateCreated"], ["desc"]);

    this.communityService.SharedFeedPostComponent.hasValue = false;
  }

  onScrollDown() {
    if (!this.hasReportedPost && !this.hasSavedPost) {
      this.pageNo++;
      this.getCommunityPost();
    }
  }

  deleteCommunityPost(id) {
    this.communityService.deleteCommunityPost(id).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        _.remove(this.postItemList, (currentObject) => {
          return currentObject.ID === +id;
        });
      } else {
        this.toaterService.error("something went wrong");
      }
    });
  }

  reportPost(id) {
    _.remove(this.postItemList, (currentObject) => {
      return currentObject.ID === +id;
    });
  }

  like(inputValue) {
    const postData = {
      PostId: inputValue.ID,
      LikedBy: +this.authService.getUserInformation()["ID"],
    };
    if (inputValue.IsLike) {
      this.communityService.likeCommunityPost(postData).subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          this.getPostById(inputValue.ID);
        } else {
          this.toaterService.error("something went wrong");
        }
      });
    } else {
      this.communityService
        .deleteCommunityPostLike(inputValue.LikeID)
        .subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            this.getPostById(inputValue.ID);
          } else {
            this.toaterService.error("something went wrong");
          }
        });
    }
  }

  bookmark(inputValue) {
    const postData = {
      PostId: inputValue.ID,
      BookmarkedBy: +this.authService.getUserInformation()["ID"],
    };
    if (inputValue.IsBookmark) {
      this.communityService
        .bookmarkCommunityPost(postData)
        .subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            if (this.hasSavedPost) {
              _.remove(this.postItemList, (currentObject) => {
                return currentObject.ID === inputValue.ID;
              });
            } else {
              this.getPostById(inputValue.ID);
            }
          } else {
            this.toaterService.error("something went wrong");
          }
        });
    } else {
      this.communityService
        .deleteCommunityPostBookmark(inputValue.BookmarkID)
        .subscribe((result) => {
          if (result.Status === ResultStatus.Success) {
            if (this.hasSavedPost) {
              _.remove(this.postItemList, (currentObject) => {
                return currentObject.ID === inputValue.ID;
              });
            } else {
              this.getPostById(inputValue.ID);
            }
          } else {
            this.toaterService.error("something went wrong");
          }
        });
    }
  }

  openUpdateModal() {
    this.modalRef = this.modalService.show(ShareUpdateComponent, {
      class: "modal-lg",
      backdrop: "static",
    });
    this.modalRef.content.closeBtnName = "Close";
    this.subscribeModalHideEvent();
  }

  openReferralModal() {
    this.modalRef = this.modalService.show(PostReferralComponent, {
      class: "modal-lg",
      backdrop: "static",
    });
    this.modalRef.content.closeBtnName = "Close";
    this.subscribeModalHideEvent();
  }

  subscribeModalHideEvent() {
    this.modalService.onHide.subscribe((result) => {
      this.pageNo = 1;
      this.getCommunityPost();
    });
  }

  share(id) {
    this.shareUrl = `${this.window.location.origin}/${this.baseShareUrl}${id}`;
    this.modalRef = this.modalService.show(
      this.shareUrlTemplate,
      Object.assign({}, { class: "modal-md" })
    );
    this.communityService.shareComunityPost(id).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.getPostById(id);
      } else {
        this.toaterService.error("something went wrong");
      }
    });
  }

  copyToClipboard() {
    document.addEventListener("copy", (e: ClipboardEvent) => {
      e.clipboardData.setData("text/plain", this.shareUrl);
      e.preventDefault();
      document.removeEventListener("copy", null);
    });
    document.execCommand("copy");

    this.toaterService.info("Link Copied");
    this.modalRef.hide();
  }

  showCommunityMobileMenu() {
    this.openCommunityMenu.emit();
  }

  changeFilter(value) {
    if (!this.helperService.isUndefinedOrNullOrEmpty(value.Tag)) {
      this.pageNo = 1;
      this.hasSavedPost = false;
      this.changeSelectedValue.emit(value);
    } else if (!this.helperService.isUndefinedOrNullOrEmpty(value.Id)) {
      this.groupId = value.Id;
      this.pageNo = 1;
      this.hasSavedPost = false;
      this.changeSelectedValue.emit(value);
      this.getCommunityPost();
    }
  }

  closeModal() {
    this.modalRef.hide();
    this.getNotificationSetting();
  }

  removeFilter(filterItem) {
    this.removeAppliedFilter.emit(filterItem);
  }

  onScrollUp() {
    // this.pageNo--;
    // this.getCommunityPost();
  }

  approvedRejectPost(value) {
    const postData = {
      PostId: value.PostId,
      Comment: "",
      ResolveBy: +this.authService.getUserInformation()["ID"],
      IsApprove: value.IsApprove,
    };
    this.communityService
      .acceptRejectCommunityPost(postData)
      .subscribe((result) => {
        if (result.Status === ResultStatus.Success) {
          if (value.IsApprove) {
            this.toaterService.success(`Post is approved successfully`);
            this.postItemList = [];
            this.getCommunityPost();
          } else {
            this.toaterService.success(`Post is rejected successfully`);
            this.postItemList = [];
            this.getCommunityPost();
          }
        }
      });
  }

  updatePost(postId) {
    this.getPostById(postId);
  }

  getPostById(postId) {
    this.communityService.getCommunityPostById(postId).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        const postDetail = result.Data;
        this.postItemList[
          this.postItemList.findIndex((item) => item.ID === postDetail.ID)
        ] = postDetail;
      } else {
        this.toaterService.error("something went wrong");
      }
    });
  }

  getNotificationSetting() {
    this.communityService.getGroupNotificationSetting(this.groupId).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.notificationSettings = {
          ID: result.Data ? result.Data.ID : 0,
          AgentID: result.Data ? result.Data.AgentID : +this.authService.getUserInformation()["ID"],
          GroupID: result.Data ? result.Data.GroupID : this.groupId,
          ImmediateUpdate: result.Data && result.Data.ImmediateUpdate ? result.Data.ImmediateUpdate : false,
          DailyUpdate: result.Data && result.Data.DailyUpdate ? result.Data.DailyUpdate : false,
          WeeklyUpdate: result.Data ? result.Data.WeeklyUpdate : false
        };
      }
    });
  }

  openGroupNotification() {
    this.groupName = this.filterValue.find(x => +x.Value === +this.groupId).Text;
    this.modalRef = this.modalService.show(
      this.notificationSettingTemplate,
      Object.assign({}, { class: "modal-dialog-centered modal-md" })
    );
  }

  saveNotificationSetting(setting) {
    this.communityService.saveGroupNotificationSetting(setting).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.closeModal();
      }
    });
  }
}

export interface NotificationSetting {
  ID: number;
  AgentID: number;
  GroupID: number;
  ImmediateUpdate: boolean;
  DailyUpdate: boolean;
  WeeklyUpdate: boolean;
}


